// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DebugWindow__debugHeader___3igLm{display:flex;margin-top:56px;padding:12px 16px;border-bottom:1px solid #dddddd;min-height:49px;justify-content:space-between;box-sizing:border-box}.DebugWindow__debugHeader_ww___3TY_a{margin-top:0}.DebugWindow__debugHeaderTitle___N5XVn{font-size:18px;font-weight:500}.DebugWindow__debugHorizontalMenu___18PNK{padding-top:4px;box-sizing:border-box}.DebugWindow__debugHorizontalMenu___18PNK-text{font-weight:500}.DebugWindow__debugHorizontalMenu___18PNK div{flex:1}.debugDrawer_ww-drawer{height:calc(100vh - 110px);left:-16px;top:24px;border:1px solid #d5d5d5;box-sizing:border-box;box-shadow:0px 1px 12px #dbdbdb;border-radius:4px}\n", ""]);
// Exports
exports.locals = {
	"debugHeader": "DebugWindow__debugHeader___3igLm",
	"debugHeader_ww": "DebugWindow__debugHeader_ww___3TY_a",
	"debugHeaderTitle": "DebugWindow__debugHeaderTitle___N5XVn",
	"debugHorizontalMenu": "DebugWindow__debugHorizontalMenu___18PNK"
};
module.exports = exports;
